export const CART_STORAGE_KEY = "noyaBibiItem";
export const CART_UPDATED_EVENT = "nuha-cart-updated";

export const getCartItems = () => {
  try {
    return JSON.parse(localStorage.getItem(CART_STORAGE_KEY) || "[]");
  } catch {
    return [];
  }
};

export const getCartItemCount = (items = getCartItems()) => items.length;

export const notifyCartUpdated = () => {
  window.dispatchEvent(new Event(CART_UPDATED_EVENT));
};

export const setCartItems = (items) => {
  localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
  notifyCartUpdated();
};

export const clearCartItems = () => {
  localStorage.removeItem(CART_STORAGE_KEY);
  notifyCartUpdated();
};
